import { Component, EventEmitter, Input, Output, signal } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Observable, BehaviorSubject, combineLatest } from "rxjs";
import { debounceTime, map, startWith } from "rxjs/operators";
import { SelectOption } from "src/app/bo/select-option";

@Component({
    selector: 'app-autocomplete',
    templateUrl: './autocomplete.component.html',
    styleUrls: ['./autocomplete.component.scss'],
  standalone: false
  })
  export class AutocompleteComponent {
    @Input() options: SelectOption[] = [];
    @Input() placeholder = 'Start typing...';
    isDropdownVisible = signal(false);
  
    @Output() optionSelected = new EventEmitter<SelectOption>();
  
    myControl = new FormControl();
    filteredOptions: Observable<SelectOption[]>;
  
    constructor() {
      this.filteredOptions = this.myControl.valueChanges.pipe(
        startWith(''),
        debounceTime(150),
        map(value => {
          const search = (value ?? '').toLowerCase();
          return this.options.filter(item =>
            item.name.toLowerCase().includes(search)
          );
        })
      );
    }
  
    onFocus(): void {
      this.myControl.setValue(this.myControl.value ?? '', { emitEvent: true });
      this.isDropdownVisible.set(true);
    }

    onBlur(): void {
      // timeout lets the click on a list item fire before hiding
      setTimeout(() => this.isDropdownVisible.set(false), 200);
    }

    selectOption(option: SelectOption) {
      this.myControl.setValue(option.name);
      this.optionSelected.emit(option);
      this.isDropdownVisible.set(false);
    }

    onInputChange() {
      this.isDropdownVisible.set(true);
    }
  }
